export const iconFontAwesomeMedicalHealthHospital = (
	<i className="fa-solid fa-hospital"></i>
);
